import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export function ParsePromotionalBadges(product: ProductModel) {
    if (product.properties["promotionalBadges"]) {
        product.promotionalBadgePaths = JSON.parse(product.properties["promotionalBadges"]);
        delete product.properties["promotionalBadges"];
    }
}

export const adjustIFrameHeight = (iframeId: string, height: string) => {
    const iframe = document.getElementById(iframeId);
    if (iframe) {
        iframe.style.height = `${parseInt(height, 10)}px`;
    };
};

export const adjustIFrameWidth = (iframeId: string, width: string) => {
    const iframe = document.getElementById(iframeId);
    if (iframe) {
        iframe.style.width = `${parseInt(width, 10)}px`;
    };
};
